import { render } from "./RiskMapPage.vue?vue&type=template&id=7f847950&scoped=true"
const script = {}

import "./RiskMapPage.vue?vue&type=style&index=0&id=7f847950&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f847950"]])

export default __exports__